<template>
	<div style="background-color: #F0F0F0;width: 100%;padding: 1px;padding: 10px 5px;">
		<h3 style="margin-bottom: 10px;">耗材分类</h3>
		<div style="display: flex;">
			<div style="width: 10%;">
				<div v-for="(s,index) in projectList"
					:style="{'border':currentIndex==index?'3px solid green':'3px solid transparent'}"
					@click="goChoose(s,index)" class="list">{{s.name}}
					<div style="position: absolute;right: 0;top: -10px;color: black;border: 1px solid #00BFAF;width: 20px;border-radius: 10px;background-color: #00BFAF;"
					v-hasPermi="['apartment:FaultMem:del']"  @click="bindDelete(s,-1)">×</div>
				</div>
				<!-- <div    :style="{'border':currentIndex==-1?'3px solid green':'3px solid transparent'}" class="list"
					@click="goAdd(0)" >
				 <span  >新增</span>	 
				</div> -->
			</div>
			<div style="width: 90%;">
				
				<el-form :model="formInline" :inline="true" label-width="80px" ref="form">
					
					<el-form-item label="耗材名称" prop="name">
						<el-input style="width: 150px;" v-model="formInline.name" placeholder="请输入耗材名称" clearable="">
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="handleQuery">搜索</el-button>
						<el-button @click="clearForm">清空</el-button>
					</el-form-item>
					<el-button v-hasPermi="['apartment:FaultMem:add']" type="primary" style="margin: 0 0 20px 15px;" @click="goAdd(0)" v-if="isAdd">新增分类</el-button>
					<el-button v-hasPermi="['apartment:FaultMem:add']" type="primary" style="margin: 0 0 20px 15px;" @click="goAdd(1)" v-if="isAdd">添加耗材</el-button>
				</el-form>
				<div class="rightList" style="width: 100%;">

					<div v-for="s in rightList"
						style="width: 23%;padding: 10px;background-color: white;margin: 0 1%;margin-bottom: 10px;">
						<div style="font-size: 16px;">名称:{{s.name}}</div>
						<!-- <div style="font-size: 14px;">图片:</div>
						<img style="width: 100%;" :src="s.showPath" alt=""> -->
						<div style="display: flex;justify-content: space-between;">
							<div style="color: #00BFAF;" @click="bindChange(s)"   v-hasPermi="['apartment:FaultMem:edit']">修改</div>
							<div style="color: #00BFAF;" @click="bindDelete(s,1)"   v-hasPermi="['apartment:FaultMem:del']">删除</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog :title="title" width="20%" :visible.sync="isShow" :close-on-click-modal="false"
			:append-to-body="false">
			<el-form ref="formline" :rules="rules" :model="formline">
				<el-form-item prop="name" v-if="isShowPic" label="耗材名称">
					<el-input v-model="formline.name" placeholder="请输入耗材分类中的小类"></el-input>
				</el-form-item>
				<el-form-item v-if="isShowPic" label="配件单价(元)">
					<el-input v-model="formline.unitPrice" placeholder="请输入配件单价"></el-input>
				</el-form-item>
				<el-form-item v-if="isShowPic" label="人工费(元)">
					<el-input v-model="formline.labourCost" placeholder="请输入人工费"></el-input>
				</el-form-item>
				<el-form-item v-if="isShowPic" label="备注">
					<el-input v-model="formline.remark " placeholder="请输入备注"></el-input>
				</el-form-item>
				<el-form-item v-if="!isShowPic" label="耗材分类">
					<el-input v-model="formline.name" placeholder="请输入耗材分类"></el-input>
				</el-form-item>
				<el-form-item v-if="isShowPic" label="封面图片">
					<el-upload class="avatar-uploader" action="/api/admin/bdRepairProject/uploadPicture"
						:show-file-list="false" :on-success="handleAvatarSuccess" :headers="headerData" name="file">
						<img style="width: 100%;" v-if="formline.showPath" :src="formline.showPath" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>

				<!-- <div style="display: flex;">
					
				</div> -->
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="close">取消</el-button>
				<el-button @click="isOk" type="primary">确定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
export default {
  data() {
    return {
      formInline: {
        name: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "耗材名称不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
      projectList: [],
      currentIndex: 0,
      rightList: [],
      isShow: false,
      formline: {
        name: "",
        filePath: "",
        showPath: "",
        pid: "",
        id: "",
        unitPrice: "",
        labourCost: 0.0,
        remark: "",
      },
      headerData: {
        Authorization: localStorage.access_token,
      },
      isAdd: false,
      isShowPic: true,
      pid: "",
      oldformline: {},
      id: "",
      title: "新增",
    };
  },
  methods: {
    handleQuery() {
      this.$http
        .post("/api/bdRepairProject/queryRepairProject", {
          ...this.formInline,
        })
        .then((res) => {
          console.log(res);
		  res.data.data.items.forEach((element) => {
            if (element.showPath) {
				element.showPath =
                "https://images.jsitc.net.cn/repair/preview" +
                element.showPath.split("/preview")[1];
            }
          });
          this.rightList = res.data.data.items;
          console.log("rightList:", JSON.stringify(this.rightList));
        });
    },
    clearForm() {
      this.formInline = {};
      this.getlist();
    },
    bindDelete(val, id) {
      this.$confirm("此操作将永久删除该故障类型, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          this.$http
            .get(`/api/bdRepairProject/deleteRepairProject?id=${val.id}`)
            .then((res) => {
              if (res.data.code == 0) {
                this.$message.success(res.data.message);
                if (id == -1) {
                  this.getlist();
                } else {
                  this.goChoose(this.id, -2);
                }
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "warning",
            message: "已取消删除",
          });
        });
    },
    bindChange(val) {
      //console.log(val)
      this.title = "修改";
      this.isShow = true;
      this.formline = JSON.parse(JSON.stringify(val));
      console.log("耗材信息：", JSON.stringify(val));
    },
    getlist() {
      this.$http
        .get("/api/bdRepairProject/getParentRepairProject")
        .then((res) => {
          this.projectList = res.data.data;
          if (this.currentIndex == 0) {
            this.formline.pid = this.projectList[0].id;
            this.isAdd = true;
            this.goChoose(res.data.data[0].id, -2);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goChoose(val, index) {
      var id;
      if (index != -2) {
        this.isAdd = true;
        this.currentIndex = index;
        this.formline.pid = this.projectList[index].id;
        id = val.id;
      } else {
        id = val;
      }
      this.id = id;
      this.$http
        .get(`/api/bdRepairProject/getChildrenRepairProject?id=${id}`)
        .then((res) => {
          console.log(res);
          res.data.data.forEach((element) => {
            if (element.showPath) {
				element.showPath =
                "https://images.jsitc.net.cn/repair/preview" +
                element.showPath.split("/preview")[1];
            }
          });

          this.rightList = res.data.data;
          //console.log('child rightList:',JSON.stringify(this.rightList))
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goAdd(val) {
      this.title = "新增";
      if (val == 0) {
        this.isAdd = false;
        this.currentIndex = -1;
        this.rightList = [];
        this.isShowPic = false;
        this.formline.pid = -1;
      } else {
        this.isShowPic = true;
      }
      this.isShow = true;
    },
    handleAvatarSuccess(file) {
      console.log(file);
      this.formline.filePath = file.data.filePath;
      this.formline.showPath = file.data.showPath;
    },
    close() {
      this.isShow = false;
    },
    isOk() {
      this.$refs.formline.validate((valid) => {
        if (valid) {
          var url;
          url = "/api/bdRepairProject/addRepairProject";
          if (this.title == "修改") {
            url = "/api/bdRepairProject/updateRepairProject";
          }
          this.$http
            .post(url, {
              ...this.formline,
            })
            .then((res) => {
              if (res.data.code == 0) {
                this.$message.success(res.data.message);
                this.isShow = false;
                this.formline = JSON.parse(JSON.stringify(this.oldformline));
                if (this.isShowPic) {
                  this.goChoose(this.id, -2);
                } else {
                  this.getlist();
                }
              } else {
                this.$message.error(res.data.message);
              }

              console.log(res);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          return;
        }
      });
    },
  },
  mounted() {
    this.oldformline = JSON.parse(JSON.stringify(this.formline));
    this.getlist();
  },
};
</script>

<style scoped="scoped">
.list {
  background-color: white;
  margin-bottom: 10px;
  text-align: center;
  padding: 5px 10px;
  position: relative;
}

.rightList {
  display: flex;
  flex-wrap: wrap;
}

.rightList > div > img {
  width: 100px;
}
</style>
